import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CreateRazerPayOrder } from "../../Services/RazerPay/Service";

export const createRazorpayOrder = createAsyncThunk(
  "razorpay/createOrder",
  async ({ Amount, InvoiceNo }, { rejectWithValue }) => {
    try {
      return await CreateRazerPayOrder(Amount, InvoiceNo);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.Message ||
        error.message ||
        "Unable to create Razorpay order."
      );
    }
  }
);

const razorpaySlice = createSlice({
  name: "razorpay",
  initialState: {
    order: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearRazorpayOrder: (state) => {
      state.order = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createRazorpayOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRazorpayOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.order = action.payload;
      })
      .addCase(createRazorpayOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unable to create Razorpay order.";
      });
  },
});

export const { clearRazorpayOrder } = razorpaySlice.actions;
export default razorpaySlice.reducer;
